import { render, staticRenderFns } from "./AppointDialog.vue?vue&type=template&id=6187cf5a&"
import script from "./AppointDialog.vue?vue&type=script&lang=js&"
export * from "./AppointDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppointDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports